// src/components/Badge.js
import React from "react";
import styled from "styled-components";

// Definindo as cores de destaque para cada status
const getStatusColor = status => {
  switch (status) {
    case "Ativo":
      return { background: "#02B8C6", color: "#fff" }; // Verde
    case "Inativo":
      return { background: "#E14C38", color: "#fff" }; // Vermelho
    case "Cancelado":
      return { background: "#E14C38", color: "#fff" }; // Vermelho
    case "Suspenso":
      return { background: "#F2BC1F", color: "#fff" }; // Amarelo
    case "Lead - Sem contrato":
      return { background: "#8E57BB", color: "#fff" }; // Cinza
    case "Chamada":
      return { background: "#E74C3C", color: "#fff" }; // Verde

    case "Registrada":
      return { background: "#3498DB", color: "#fff" }; // Verde

    case "Serviço Corretivo":
      return { background: "#F39C12", color: "#fff" }; // Verde
    case "Manutenção Preventiva":
      return { background: "#9B59B6", color: "#fff" }; // Verde
    default:
      return { background: "#007bff", color: "#fff" }; // Azul padrão
  }
};

// Componente Badge estilizado
const StyledBadge = styled.span`
  display: inline-block;
  margin-bottom: -2px;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 300;
  text-transform: lowercase;
  color: ${({ status }) => getStatusColor(status).color};
  background-color: ${({ status }) => getStatusColor(status).background};
`;

const Badge = ({ status }) =>
  <StyledBadge status={status}>
    {status}
  </StyledBadge>;

export default Badge;
